export const tr = {
    'many-platforms-count': '{selectedCount} / {totalCount} ekran',
    'many-screens-count': '{selectedCount} ekran',
    'nothing-found': 'Sonuç bulunamadı',
    'one-platforms-count': '{selectedCount} / {totalCount} ekran',
    'one-screens-count': '{selectedCount} ekran',
    'some-platforms-count': '{selectedCount} / {totalCount} ekran',
    'some-screens-count': '{selectedCount} ekran'
};
